<template>
  <!-- <svg-icon name="logo" v-if="!$store.state.is_loading" /> -->
  <div class="svg" ref="svg" @click="top"></div>
  <footer class="footer">
    <div class="footer-inner">
      <div class="left">
        <ul>
          <li v-for="(item, index) in menus" :key="index">
            <ui-link :to="item.url">{{ item.cn }}</ui-link>
          </li>
          <li>
            <a href="https://mailchi.mp/84a47b5f3d4b/cawa" target="_blank" rel="noopener"> 订阅 </a>
          </li>
        </ul>
        <p>
          <ui-link to="/term-conditions">Terms & Conditions<br />服务条款</ui-link>
        </p>
        <div class="split">
          <a href="https://www.instagram.com/cawa_art_cawa/" target="_blank" rel="noopener"> CAWA INSTAGRAM </a>
          <p>©{{ year }} CAWA.ART</p>
        </div>
      </div>
      <div class="right">
        <ul>
          <li v-for="(item, index) in menus" :key="index">
            <ui-link :to="item.url">{{ item.en }}</ui-link>
          </li>
          <li>
            <a href="https://mailchi.mp/84a47b5f3d4b/cawa" target="_blank" rel="noopener"> Subscribe </a>
          </li>
        </ul>
        <p>特别支持<br />Supported by</p>
        <p><svg-icon name="chanel" /></p>
      </div>
    </div>
  </footer>
</template>

<script>
import lottie from 'lottie-web';

export default {
  name: 'Footer',

  data() {
    return {
      year: new Date().getFullYear(),
      menus: [
        {
          cn: '关于我们',
          en: 'About',
          url: '/about',
        },
        {
          cn: '艺术家',
          en: 'Artists',
          url: '/artists',
        },
        {
          cn: '动向',
          en: 'Latest',
          url: '/latest',
        },
        {
          cn: '专题',
          en: 'Features',
          url: '/features',
        },
        {
          cn: '文献馆',
          en: 'Library',
          url: '/library',
        },
      ],
      in_view: false,
      params: {
        container: this.$refs.el,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: {
          v: '4.8.0',
          meta: { g: 'LottieFiles AE 3.5.4', a: '', k: '', d: '', tc: '' },
          fr: 29.9700012207031,
          ip: 0,
          op: 180.00000733155,
          w: 425,
          h: 1020,
          nm: 'Full Logo – Vertical',
          ddd: 0,
          assets: [
            {
              id: 'comp_0',
              layers: [
                {
                  ddd: 0,
                  ind: 1,
                  ty: 4,
                  nm: 'C – Top',
                  sr: 1,
                  ks: {
                    o: { a: 0, k: 100, ix: 11 },
                    r: { a: 0, k: 0, ix: 10 },
                    p: { a: 0, k: [510.235, 212.598, 0], ix: 2 },
                    a: { a: 0, k: [510.235, 212.598, 0], ix: 1 },
                    s: { a: 0, k: [100, 100, 100], ix: 6 },
                  },
                  ao: 0,
                  shapes: [
                    {
                      ty: 'gr',
                      it: [
                        {
                          ind: 0,
                          ty: 'sh',
                          ix: 1,
                          ks: {
                            a: 0,
                            k: {
                              i: [
                                [0, 0],
                                [-8.935, 1.14],
                                [-8.906, 0],
                                [-8.606, -1.079],
                                [-8.546, -2.249],
                                [-27.617, -40.78],
                              ],
                              o: [
                                [8.546, -2.249],
                                [8.606, -1.079],
                                [8.905, 0],
                                [8.606, 1.08],
                                [48.967, 12.834],
                                [0, 0],
                              ],
                              v: [
                                [-111.756, -38.636],
                                [-85.489, -43.734],
                                [-59.221, -45.383],
                                [-32.954, -43.734],
                                [-6.687, -38.636],
                                [111.756, 45.383],
                              ],
                              c: false,
                            },
                            ix: 2,
                          },
                          nm: 'Path 1',
                          mn: 'ADBE Vector Shape - Group',
                          hd: false,
                        },
                        {
                          ty: 'st',
                          c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                          o: { a: 0, k: 100, ix: 4 },
                          w: { a: 0, k: 13.344, ix: 5 },
                          lc: 1,
                          lj: 2,
                          bm: 0,
                          nm: 'Stroke 1',
                          mn: 'ADBE Vector Graphic - Stroke',
                          hd: false,
                        },
                        {
                          ty: 'tr',
                          p: { a: 0, k: [170.885, 52.017], ix: 2 },
                          a: { a: 0, k: [0, 0], ix: 1 },
                          s: { a: 0, k: [100, 100], ix: 3 },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: 'Transform',
                        },
                      ],
                      nm: 'Group 1',
                      np: 2,
                      cix: 2,
                      bm: 0,
                      ix: 1,
                      mn: 'ADBE Vector Group',
                      hd: false,
                    },
                    {
                      ty: 'tm',
                      s: {
                        a: 1,
                        k: [
                          { i: { x: [0.833], y: [0.833] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                          { t: 20.0000008146167, s: [100] },
                        ],
                        ix: 1,
                      },
                      e: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0.167] }, t: 108, s: [0] },
                          { t: 128.000005213547, s: [100] },
                        ],
                        ix: 2,
                      },
                      o: { a: 0, k: 0, ix: 3 },
                      m: 1,
                      ix: 2,
                      nm: 'Trim Paths 1',
                      mn: 'ADBE Vector Filter - Trim',
                      hd: false,
                    },
                  ],
                  ip: 0,
                  op: 184.000007494474,
                  st: 0,
                  bm: 0,
                },
                {
                  ddd: 0,
                  ind: 2,
                  ty: 4,
                  nm: 'C – Middle',
                  sr: 1,
                  ks: {
                    o: { a: 0, k: 100, ix: 11 },
                    r: { a: 0, k: 0, ix: 10 },
                    p: { a: 0, k: [510.235, 212.598, 0], ix: 2 },
                    a: { a: 0, k: [510.235, 212.598, 0], ix: 1 },
                    s: { a: 0, k: [100, 100, 100], ix: 6 },
                  },
                  ao: 0,
                  shapes: [
                    {
                      ty: 'gr',
                      it: [
                        {
                          ind: 0,
                          ty: 'sh',
                          ix: 1,
                          ks: {
                            a: 0,
                            k: {
                              i: [
                                [0, 0],
                                [6.956, -1.319],
                                [6.777, 0],
                                [6.417, 1.23],
                                [6.327, 2.579],
                                [0, 43.749],
                                [-38.201, 15.593],
                                [-6.867, 1.32],
                                [-6.776, 0],
                                [-6.417, -1.229],
                                [-6.327, -2.578],
                              ],
                              o: [
                                [-6.387, 2.639],
                                [-6.417, 1.23],
                                [-6.776, 0],
                                [-6.867, -1.319],
                                [-38.201, -15.593],
                                [0, -43.749],
                                [6.327, -2.578],
                                [6.417, -1.229],
                                [6.777, 0],
                                [6.866, 1.32],
                                [0, 0],
                              ],
                              v: [
                                [72.325, 96.734],
                                [52.265, 102.7],
                                [32.444, 104.559],
                                [12.624, 102.7],
                                [-7.197, 96.824],
                                [-72.325, 0.001],
                                [-7.197, -96.824],
                                [12.624, -102.701],
                                [32.444, -104.559],
                                [52.265, -102.701],
                                [72.085, -96.824],
                              ],
                              c: false,
                            },
                            ix: 2,
                          },
                          nm: 'Path 1',
                          mn: 'ADBE Vector Shape - Group',
                          hd: false,
                        },
                        {
                          ty: 'st',
                          c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                          o: { a: 0, k: 100, ix: 4 },
                          w: { a: 0, k: 13.344, ix: 5 },
                          lc: 1,
                          lj: 2,
                          bm: 0,
                          nm: 'Stroke 1',
                          mn: 'ADBE Vector Graphic - Stroke',
                          hd: false,
                        },
                        {
                          ty: 'tr',
                          p: { a: 0, k: [79.219, 212.484], ix: 2 },
                          a: { a: 0, k: [0, 0], ix: 1 },
                          s: { a: 0, k: [100, 100], ix: 3 },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: 'Transform',
                        },
                      ],
                      nm: 'Group 1',
                      np: 2,
                      cix: 2,
                      bm: 0,
                      ix: 1,
                      mn: 'ADBE Vector Group',
                      hd: false,
                    },
                    {
                      ty: 'tm',
                      s: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [100] },
                          { t: 50.0000020365418, s: [0] },
                        ],
                        ix: 1,
                      },
                      e: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 100, s: [100] },
                          { t: 150.000006109625, s: [0] },
                        ],
                        ix: 2,
                      },
                      o: { a: 0, k: 0, ix: 3 },
                      m: 1,
                      ix: 2,
                      nm: 'Trim Paths 1',
                      mn: 'ADBE Vector Filter - Trim',
                      hd: false,
                    },
                  ],
                  ip: 0,
                  op: 184.000007494474,
                  st: 0,
                  bm: 0,
                },
                {
                  ddd: 0,
                  ind: 3,
                  ty: 4,
                  nm: 'C – Bottom',
                  sr: 1,
                  ks: {
                    o: { a: 0, k: 100, ix: 11 },
                    r: { a: 0, k: 0, ix: 10 },
                    p: { a: 0, k: [510.235, 212.598, 0], ix: 2 },
                    a: { a: 0, k: [510.235, 212.598, 0], ix: 1 },
                    s: { a: 0, k: [100, 100, 100], ix: 6 },
                  },
                  ao: 0,
                  shapes: [
                    {
                      ty: 'gr',
                      it: [
                        {
                          ind: 0,
                          ty: 'sh',
                          ix: 1,
                          ks: {
                            a: 0,
                            k: {
                              i: [
                                [0, 0],
                                [49.207, -12.773],
                                [8.756, -1.109],
                                [8.905, 0],
                                [8.606, 1.079],
                                [8.546, 2.219],
                              ],
                              o: [
                                [-27.707, 40.93],
                                [-8.395, 2.189],
                                [-8.606, 1.079],
                                [-8.906, 0],
                                [-8.935, -1.14],
                                [0, 0],
                              ],
                              v: [
                                [111.756, -45.368],
                                [-7.227, 38.771],
                                [-32.954, 43.719],
                                [-59.251, 45.368],
                                [-85.519, 43.719],
                                [-111.756, 38.651],
                              ],
                              c: false,
                            },
                            ix: 2,
                          },
                          nm: 'Path 1',
                          mn: 'ADBE Vector Shape - Group',
                          hd: false,
                        },
                        {
                          ty: 'st',
                          c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                          o: { a: 0, k: 100, ix: 4 },
                          w: { a: 0, k: 13.344, ix: 5 },
                          lc: 1,
                          lj: 2,
                          bm: 0,
                          nm: 'Stroke 1',
                          mn: 'ADBE Vector Graphic - Stroke',
                          hd: false,
                        },
                        {
                          ty: 'tr',
                          p: { a: 0, k: [170.885, 372.937], ix: 2 },
                          a: { a: 0, k: [0, 0], ix: 1 },
                          s: { a: 0, k: [100, 100], ix: 3 },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: 'Transform',
                        },
                      ],
                      nm: 'Group 1',
                      np: 2,
                      cix: 2,
                      bm: 0,
                      ix: 1,
                      mn: 'ADBE Vector Group',
                      hd: false,
                    },
                    {
                      ty: 'tm',
                      s: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0.167] }, t: 24, s: [0] },
                          { t: 42.0000017106951, s: [100] },
                        ],
                        ix: 1,
                      },
                      e: {
                        a: 1,
                        k: [
                          { i: { x: [0.833], y: [0.833] }, o: { x: [0.333], y: [0] }, t: 132, s: [0] },
                          { t: 150.000006109625, s: [100] },
                        ],
                        ix: 2,
                      },
                      o: { a: 0, k: 0, ix: 3 },
                      m: 1,
                      ix: 2,
                      nm: 'Trim Paths 1',
                      mn: 'ADBE Vector Filter - Trim',
                      hd: false,
                    },
                  ],
                  ip: 0,
                  op: 183.000007453743,
                  st: 0,
                  bm: 0,
                },
                {
                  ddd: 0,
                  ind: 4,
                  ty: 4,
                  nm: 'AWA– large',
                  sr: 1,
                  ks: {
                    o: { a: 0, k: 100, ix: 11 },
                    r: { a: 0, k: 0, ix: 10 },
                    p: { a: 0, k: [510.235, 212.598, 0], ix: 2 },
                    a: { a: 0, k: [510.235, 212.598, 0], ix: 1 },
                    s: { a: 0, k: [100, 100, 100], ix: 6 },
                  },
                  ao: 0,
                  shapes: [
                    {
                      ty: 'gr',
                      it: [
                        {
                          ind: 0,
                          ty: 'sh',
                          ix: 1,
                          ks: {
                            a: 0,
                            k: {
                              i: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [-354.728, 1.679],
                                [-259.104, -202.882],
                                [-70.675, 202.882],
                                [0.001, 4.108],
                                [70.707, 202.882],
                                [259.106, -202.882],
                                [354.729, 1.679],
                              ],
                              c: false,
                            },
                            ix: 2,
                          },
                          nm: 'Path 1',
                          mn: 'ADBE Vector Shape - Group',
                          hd: false,
                        },
                        {
                          ty: 'st',
                          c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                          o: { a: 0, k: 100, ix: 4 },
                          w: { a: 0, k: 13.344, ix: 5 },
                          lc: 1,
                          lj: 2,
                          bm: 0,
                          nm: 'Stroke 1',
                          mn: 'ADBE Vector Graphic - Stroke',
                          hd: false,
                        },
                        {
                          ty: 'tr',
                          p: { a: 0, k: [659.408, 212.365], ix: 2 },
                          a: { a: 0, k: [0, 0], ix: 1 },
                          s: { a: 0, k: [100, 100], ix: 3 },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: 'Transform',
                        },
                      ],
                      nm: 'Group 1',
                      np: 2,
                      cix: 2,
                      bm: 0,
                      ix: 1,
                      mn: 'ADBE Vector Group',
                      hd: false,
                    },
                    {
                      ty: 'tm',
                      s: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 100, s: [100] },
                          { t: 150.000006109625, s: [0] },
                        ],
                        ix: 1,
                      },
                      e: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [100] },
                          { t: 50.0000020365418, s: [0] },
                        ],
                        ix: 2,
                      },
                      o: { a: 0, k: 0, ix: 3 },
                      m: 1,
                      ix: 2,
                      nm: 'Trim Paths 1',
                      mn: 'ADBE Vector Filter - Trim',
                      hd: false,
                    },
                  ],
                  ip: 0,
                  op: 183.000007453743,
                  st: 0,
                  bm: 0,
                },
                {
                  ddd: 0,
                  ind: 5,
                  ty: 4,
                  nm: 'AWA – W',
                  sr: 1,
                  ks: {
                    o: { a: 0, k: 100, ix: 11 },
                    r: { a: 0, k: 0, ix: 10 },
                    p: { a: 0, k: [510.235, 212.598, 0], ix: 2 },
                    a: { a: 0, k: [510.235, 212.598, 0], ix: 1 },
                    s: { a: 0, k: [100, 100, 100], ix: 6 },
                  },
                  ao: 0,
                  shapes: [
                    {
                      ty: 'gr',
                      it: [
                        {
                          ind: 0,
                          ty: 'sh',
                          ix: 1,
                          ks: {
                            a: 0,
                            k: {
                              i: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [165.22, -102.611],
                                [70.706, 102.611],
                                [0, -96.194],
                                [-70.676, 102.611],
                                [-165.22, -102.611],
                              ],
                              c: false,
                            },
                            ix: 2,
                          },
                          nm: 'Path 1',
                          mn: 'ADBE Vector Shape - Group',
                          hd: false,
                        },
                        {
                          ty: 'st',
                          c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                          o: { a: 0, k: 100, ix: 4 },
                          w: { a: 0, k: 13.344, ix: 5 },
                          lc: 1,
                          lj: 2,
                          bm: 0,
                          nm: 'Stroke 1',
                          mn: 'ADBE Vector Graphic - Stroke',
                          hd: false,
                        },
                        {
                          ty: 'tr',
                          p: { a: 0, k: [659.409, 106.186], ix: 2 },
                          a: { a: 0, k: [0, 0], ix: 1 },
                          s: { a: 0, k: [100, 100], ix: 3 },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: 'Transform',
                        },
                      ],
                      nm: 'Group 1',
                      np: 2,
                      cix: 2,
                      bm: 0,
                      ix: 1,
                      mn: 'ADBE Vector Group',
                      hd: false,
                    },
                    {
                      ty: 'tm',
                      s: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [100] },
                          { t: 50.0000020365418, s: [0] },
                        ],
                        ix: 1,
                        x: "var $bm_rt;\n$bm_rt = content('Trim Paths 1').start;",
                      },
                      e: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 100, s: [100] },
                          { t: 150.000006109625, s: [0] },
                        ],
                        ix: 2,
                      },
                      o: { a: 0, k: 0, ix: 3 },
                      m: 1,
                      ix: 2,
                      nm: 'Trim Paths 1',
                      mn: 'ADBE Vector Filter - Trim',
                      hd: false,
                    },
                  ],
                  ip: 0,
                  op: 183.000007453743,
                  st: 0,
                  bm: 0,
                },
                {
                  ddd: 0,
                  ind: 6,
                  ty: 4,
                  nm: 'AWA – A (Left)',
                  sr: 1,
                  ks: {
                    o: { a: 0, k: 100, ix: 11 },
                    r: { a: 0, k: 0, ix: 10 },
                    p: { a: 0, k: [510.235, 212.598, 0], ix: 2 },
                    a: { a: 0, k: [510.235, 212.598, 0], ix: 1 },
                    s: { a: 0, k: [100, 100, 100], ix: 6 },
                  },
                  ao: 0,
                  shapes: [
                    {
                      ty: 'gr',
                      it: [
                        {
                          ind: 0,
                          ty: 'sh',
                          ix: 1,
                          ks: {
                            a: 0,
                            k: {
                              i: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [95.624, 102.28],
                                [0, -102.281],
                                [-95.624, 102.28],
                              ],
                              c: false,
                            },
                            ix: 2,
                          },
                          nm: 'Path 1',
                          mn: 'ADBE Vector Shape - Group',
                          hd: false,
                        },
                        {
                          ty: 'st',
                          c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                          o: { a: 0, k: 100, ix: 4 },
                          w: { a: 0, k: 13.344, ix: 5 },
                          lc: 1,
                          lj: 2,
                          bm: 0,
                          nm: 'Stroke 1',
                          mn: 'ADBE Vector Graphic - Stroke',
                          hd: false,
                        },
                        {
                          ty: 'tr',
                          p: { a: 0, k: [400.304, 319.113], ix: 2 },
                          a: { a: 0, k: [0, 0], ix: 1 },
                          s: { a: 0, k: [100, 100], ix: 3 },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: 'Transform',
                        },
                      ],
                      nm: 'Group 1',
                      np: 2,
                      cix: 2,
                      bm: 0,
                      ix: 1,
                      mn: 'ADBE Vector Group',
                      hd: false,
                    },
                    {
                      ty: 'tm',
                      s: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 5, s: [100] },
                          { t: 50.0000020365418, s: [0] },
                        ],
                        ix: 1,
                      },
                      e: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 100, s: [100] },
                          { t: 145.000005905971, s: [0] },
                        ],
                        ix: 2,
                      },
                      o: { a: 0, k: 0, ix: 3 },
                      m: 1,
                      ix: 2,
                      nm: 'Trim Paths 1',
                      mn: 'ADBE Vector Filter - Trim',
                      hd: false,
                    },
                  ],
                  ip: 0,
                  op: 183.000007453743,
                  st: 0,
                  bm: 0,
                },
                {
                  ddd: 0,
                  ind: 7,
                  ty: 4,
                  nm: 'AWA – A (Right)',
                  sr: 1,
                  ks: {
                    o: { a: 0, k: 100, ix: 11 },
                    r: { a: 0, k: 0, ix: 10 },
                    p: { a: 0, k: [510.235, 212.598, 0], ix: 2 },
                    a: { a: 0, k: [510.235, 212.598, 0], ix: 1 },
                    s: { a: 0, k: [100, 100, 100], ix: 6 },
                  },
                  ao: 0,
                  shapes: [
                    {
                      ty: 'gr',
                      it: [
                        {
                          ind: 0,
                          ty: 'sh',
                          ix: 1,
                          ks: {
                            a: 0,
                            k: {
                              i: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [95.624, 102.28],
                                [0, -102.281],
                                [-95.624, 102.28],
                              ],
                              c: false,
                            },
                            ix: 2,
                          },
                          nm: 'Path 1',
                          mn: 'ADBE Vector Shape - Group',
                          hd: false,
                        },
                        {
                          ty: 'st',
                          c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                          o: { a: 0, k: 100, ix: 4 },
                          w: { a: 0, k: 13.344, ix: 5 },
                          lc: 1,
                          lj: 2,
                          bm: 0,
                          nm: 'Stroke 1',
                          mn: 'ADBE Vector Graphic - Stroke',
                          hd: false,
                        },
                        {
                          ty: 'tr',
                          p: { a: 0, k: [918.514, 319.113], ix: 2 },
                          a: { a: 0, k: [0, 0], ix: 1 },
                          s: { a: 0, k: [100, 100], ix: 3 },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: 'Transform',
                        },
                      ],
                      nm: 'Group 1',
                      np: 2,
                      cix: 2,
                      bm: 0,
                      ix: 1,
                      mn: 'ADBE Vector Group',
                      hd: false,
                    },
                    {
                      ty: 'tm',
                      s: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 100, s: [0] },
                          { t: 145.000005905971, s: [100] },
                        ],
                        ix: 1,
                      },
                      e: {
                        a: 1,
                        k: [
                          { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 5, s: [0] },
                          { t: 50.0000020365418, s: [100] },
                        ],
                        ix: 2,
                      },
                      o: { a: 0, k: 0, ix: 3 },
                      m: 1,
                      ix: 2,
                      nm: 'Trim Paths 1',
                      mn: 'ADBE Vector Filter - Trim',
                      hd: false,
                    },
                  ],
                  ip: 0,
                  op: 184.000007494474,
                  st: 0,
                  bm: 0,
                },
              ],
            },
          ],
          layers: [
            {
              ddd: 0,
              ind: 1,
              ty: 0,
              nm: 'Full Logo – Horizontal',
              refId: 'comp_0',
              sr: 1,
              ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 90, ix: 10 },
                p: { a: 0, k: [212.5, 510, 0], ix: 2 },
                a: { a: 0, k: [510, 212.5, 0], ix: 1 },
                s: { a: 0, k: [100, 100, 100], ix: 6 },
              },
              ao: 0,
              w: 1020,
              h: 425,
              ip: 0,
              op: 149.000006068894,
              st: 0,
              bm: 0,
            },
          ],
          markers: [],
        },
      },
    };
  },

  methods: {
    isElementInView(el) {
      if (el === null) return false;
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    handleScroll() {
      if (!this.in_view && this.isElementInView(this.$refs.svg)) {
        this.in_view = true;
        this.params.container = this.$refs.svg;
        lottie.loadAnimation(this.params);
      }
    },
    top() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },

  // mounted() {
  //     this.params.container = this.$refs.svg;
  //     // const anim = lottie.loadAnimation(this.params);
  // },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style lang="scss">
.svg {
  // width: 4rem;
  height: 12rem;
  margin: 15rem auto 6rem;
  display: block;
  cursor: pointer;
}

.footer {
  background-color: white;
  overflow: hidden;
  width: 100vw;

  .footer-inner {
    display: flex;
    padding: var(--padding-x6) var(--padding-x4);
    padding-bottom: 0px;
    text-transform: uppercase;
    margin: 0 auto;
    max-width: var(--max-width);

    ul {
      display: flex;
      flex-wrap: wrap;
      margin: 0 var(--padding-50-neg);

      :nth-last-child(3) a,
      :nth-last-child(2) a,
      :last-child a {
        border-bottom: 1px solid var(--font-color);
      }

      @media screen and (max-width: 780px) {
        li:last-child a {
          border-bottom: 1px solid var(--font-color);
        }

        :nth-last-child(3) a,
        :nth-last-child(2) a {
          border-bottom: 0px solid var(--font-color);
        }
      }

      li {
        width: 33.33%;
        padding: 0 var(--padding-50);
        box-sizing: border-box;

        a {
          display: block;
          text-align: center;
          font-size: var(--base-size);
          padding: var(--padding) 0;
          border-top: 1px solid var(--font-color);
          margin-top: -1px;
          position: relative;
          transition: 0.2s all ease;

          &::before {
            content: '';
            display: block;
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: var(--blue);
            opacity: 0;
            transition: 0.2s all ease;
          }

          &:hover::before {
            opacity: 0.3;
          }
        }
      }
    }

    .left {
      width: 50%;
      padding-right: var(--padding-x4);
      box-sizing: border-box;
      padding-bottom: var(--padding-x4);

      .split {
        display: flex;
        justify-content: center;

        p,
        a {
          font-size: 80%;
          padding: 0;
          margin: auto;
          padding-top: var(--padding-x6);
          border: 0px;
        }
      }
    }

    .right {
      width: 50%;
      padding-left: var(--padding-x4);
      box-sizing: border-box;
      padding-bottom: var(--padding-x4);
    }

    & > div {
      p {
        text-align: center;
        font-size: 80%;

        &:nth-child(2) {
          margin: 12rem 0 0;
          border-top: 1px solid var(--font-color);
          padding: var(--padding-x2) 0 0;
        }

        &:nth-child(3) {
          padding: var(--padding-x4) 0;
        }
      }

      .svg-icon--chanel {
        height: 4rem;
        width: 10rem;
        display: block;
        margin: 0 auto;
        position: relative;
        top: -1.5rem;
      }
    }
  }

  @media screen and (max-width: 780px) {
    .footer-inner {
      padding: var(--padding-x2) 0;
      padding-bottom: 0;
      margin: 0;
      flex-wrap: wrap;

      ul {
        margin: 0;

        li {
          width: 100%;
          padding: 0 var(--padding-50);

          a {
            padding: var(--padding-50) 0;
          }
        }
      }

      .left {
        width: 50%;
        padding-right: var(--padding-50);
        order: 1;
        padding-bottom: var(--padding-x3);

        .split {
          display: flex;
          flex-wrap: wrap;

          p,
          a {
            font-size: 80%;
            padding: 0;
            width: 100%;
            margin: 0;
            border: 0px;
            text-align: center;
          }

          a {
            padding-top: var(--padding);
          }
        }
      }

      .right {
        width: 50%;
        padding-left: var(--padding-50);
        padding-bottom: var(--padding-x3);
      }

      & > div {
        p {
          text-align: center;
          font-size: 80%;

          &:nth-child(2) {
            margin: 0;
            padding: var(--padding-x2) 0 0;
            border: none;
          }

          &:nth-child(3) {
            padding: var(--padding-x2) 0;
          }
        }
      }
    }
  }
}
</style>
